export default () => {
  const cookieName = 'mw_cart_amount'
  const navCarts = document.getElementsByClassName('cart-contents-count')
  let quantityArray

  const updateNavCart = () => {
    Array.prototype.forEach.call(navCarts, (cart) => {
      cart.innerText = Cookies.get(cookieName) ? Cookies.get(cookieName) : ''
    })
    Array.prototype.forEach.call(
      document.querySelectorAll('#cart'),
      (cartWrapper, i) => {
        if (navCarts[i].innerText) {
          cartWrapper.classList.add('filled')
        } else cartWrapper.classList.remove('filled')
      }
    )
  }

  const setCookie = (action, value) => {
    const currentValue = Cookies.get(cookieName)
      ? parseInt(Cookies.get(cookieName), 10)
      : 0
    if (action === 'add') {
      Cookies.set(cookieName, currentValue + parseInt(value, 10), {
        secure: true,
      })
    } else if (action === 'remove') {
      if (currentValue > value) {
        Cookies.set(cookieName, currentValue - parseInt(value, 10), {
          secure: true,
        })
      } else {
        Cookies.remove(cookieName)
      }
    } else if (action === 'set') {
      Cookies.set(cookieName, value, { secure: true })
    }
    updateNavCart()
  }

  const createQuantityArray = () => {
    const items = document.getElementsByClassName(
      'woocommerce-cart-form__cart-item'
    )

    if (items.length > 0) {
      const itemQuantity = Array.prototype.map.call(items, (el) =>
        parseInt(el.children[3].children[0].children[1].value, 10)
      )
      quantityArray = itemQuantity
      return itemQuantity.reduce((acc, curr) => acc + curr)
    } else return 0
  }

  const addToCart = (productId, quantity) => {
    if ('undefined' === typeof wc_add_to_cart_params) return false

    const data = {
      product_id: productId,
      quantity: quantity,
    }

    jQuery.post(
      wc_add_to_cart_params.wc_ajax_url
        .toString()
        .replace('%%endpoint%%', 'add_to_cart'),
      data,
      function(response) {
        if (!response) return
        jQuery('#cart').addClass('animateBackgroundColor')
        setTimeout(() => {
          jQuery('#cart').removeClass('animateBackgroundColor')
        }, 500)
      }
    )
  }

  const handleAddClick = (e) => {
    const quantity =
      document.getElementsByClassName('single_add_to_cart_button')[0] &&
      document
        .getElementsByClassName('single_add_to_cart_button')[0]
        .previousElementSibling.classList.contains('quantity')
        ? document.getElementsByClassName('single_add_to_cart_button')[0]
            .previousElementSibling.children[1].value
        : 1

    let productId = null
    const url = e.currentTarget.getAttribute('href')
      ? new URL(e.currentTarget.getAttribute('href'))
      : null

    if (url) productId = url.searchParams.get('add-to-cart')

    setCookie('add', quantity)

    if (url) {
      addToCart(productId, quantity)
      e.preventDefault()
      return false
    }
  }

  const handleRemoveClick = (e) => {
    const clickedRow =
      e.target.parentElement.tagName === 'TD'
        ? e.target.parentElement.parentElement
        : e.target.parentElement.parentElement.parentElement
    const i = Array.from(clickedRow.parentNode.children).indexOf(clickedRow)
    Cookies.set(cookieName + '_backup', Cookies.get(cookieName), {
      secure: true,
    })
    setCookie('remove', quantityArray[i])
  }

  const handleRestoreClick = () => {
    setCookie('set', Cookies.get(cookieName + '_backup'))
    Cookies.remove(cookieName + '_backup')
  }

  const handleResetClick = () => {
    const checkboxes = document.getElementsByClassName('checkbox')

    if (
      checkboxes.length > 0 &&
      Array.prototype.every.call(checkboxes, (el) =>
        el.children[0].classList.contains('checked')
      )
    ) {
      Cookies.remove(cookieName)
      Cookies.remove(cookieName + '_backup')
      updateNavCart()
    }
  }

  const handleUpdateClick = () => {
    setCookie('set', createQuantityArray())
  }

  const setupHandlers = () => {
    const shopCartAddButtons = document.getElementsByClassName(
      'product-preview__checkout'
    )
    const singleCartAddButton = document.getElementsByClassName(
      'single_add_to_cart_button'
    )[0]
    const cartRemoveButtons = document.getElementsByClassName('remove')
    const cartResetButton = document.getElementById('place_order')
    const cartRestoreButton = document.getElementsByClassName('restore-item')[0]
    const cartUpdateButton = document.getElementsByName('update_cart')[0]

    if (shopCartAddButtons.length > 0) {
      Array.prototype.forEach.call(shopCartAddButtons, (el) => {
        el.removeEventListener('click', handleAddClick)
        el.addEventListener('click', handleAddClick)
      })
    }

    if (singleCartAddButton) {
      singleCartAddButton.removeEventListener('click', handleAddClick)
      singleCartAddButton.addEventListener('click', handleAddClick)
    }

    if (cartRemoveButtons.length > 0) {
      Array.prototype.forEach.call(cartRemoveButtons, (el) => {
        el.removeEventListener('click', handleRemoveClick)
        el.addEventListener('click', handleRemoveClick)
      })
    }

    if (cartRestoreButton) {
      cartRestoreButton.removeEventListener('click', handleRestoreClick)
      cartRestoreButton.addEventListener('click', handleRestoreClick)
    }

    if (
      cartResetButton &&
      cartResetButton.value === 'Zahlungspflichtig bestellen'
    ) {
      cartResetButton.removeEventListener('click', handleResetClick)
      cartResetButton.addEventListener('click', handleResetClick)
    }

    if (cartUpdateButton) {
      cartUpdateButton.removeEventListener('click', handleUpdateClick)
      cartUpdateButton.addEventListener('click', handleUpdateClick)
    }

    setTimeout(setupHandlers, 500)
  }

  if (document.getElementsByClassName('remove').length > 0) {
    setCookie('set', createQuantityArray())
  }

  // on cart page & cart empty
  if (
    jQuery('body.woocommerce-cart').length > 0 &&
    jQuery('.cart-empty').length > 0
  ) {
    setCookie('set', 0)
  }

  updateNavCart()
  setupHandlers()
  Cookies.remove(cookieName + '_backup')
}
